"use client";
import { createContext } from "../../utils/create-context.js";
//#region src/components/checkbox/use-checkbox-context.ts
var [CheckboxProvider, useCheckboxContext] = createContext({
	name: "CheckboxContext",
	hookName: "useCheckboxContext",
	providerName: "<CheckboxProvider />"
});
//#endregion
export { CheckboxProvider, useCheckboxContext };
